// --
import React from 'react';
import AbstractReactComponent from "../AbstractReactComponent";
import classNames from 'classnames';

import "./PageContent.scss";

/**
 * Komponenta pro vlastní obsah stránky, podporuje vložení hlavičky stránky, která je nad všemi sekcemi a není scrolovatelná.
 * Komponenta podporuje sekce: leftPanel, rightPanel, ty jsou předávány jako props a mohou být zabalovatelné.
 * Komponenta podporuje center panel, který je předáván jako children.
 */
class PageContent extends AbstractReactComponent {
    static propTypes = {
        fluid: React.PropTypes.bool,    // pokud je true, vytvoří se fluid container, jinak se vytvoří standardní kontainer, implicitně je false
        fullWidth: React.PropTypes.bool,    // pokud je true, nejsou u jednotlivých sekcí žádné okraje, stejně tak má při fullWidth pozadí pro umisťování kartiček
        header: React.PropTypes.oneOfType([    // pokud je uvedeno, obsahuje hlavičku stránky, ta je nescrolovatelná
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        leftPanel: React.PropTypes.oneOfType([    // pokud je uvedeno, obsahuje obsah levého panelu, pokud není uvedeno, levý panel se vůbec nezobrazí
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        rightPanel: React.PropTypes.oneOfType([    // pokud je uvedeno, obsahuje obsah pravého panelu, pokud není uvedeno, pravý panel se vůbec nezobrazí
            React.PropTypes.array,
            React.PropTypes.node
        ]),
        rightPanelClassName: React.PropTypes.string,    // class name pro pravý panel
        leftPanelClassName: React.PropTypes.string,    // class name pro levý panel
        centerPanelClassName: React.PropTypes.string,    // class name pro prostřední panel
        appContainer: React.PropTypes.bool, // má se vkládat app container do headeru a contentu? Implicitně true.
    };

    static defaultProps = {
        fluid: false,
        appContainer: true
    };

    render() {
        const {centerPanelClassName, leftPanelClassName, rightPanelClassName, fullWidth, appContainer, className, header, fluid, children, leftPanel, rightPanel} = this.props;

        const wrapperClassNames = classNames(
            className,
            "page-content-wrapper",
            {
                "has-header": header ? true : false,
                "full-width": fullWidth
            }
        );
        const contentClassNames = classNames(
            "page-content-content",
        );
        const headerClassNames = classNames(
            "page-content-header",
        );
        const rightPanelClassNames = classNames(
            "page-content-right-panel", rightPanelClassName
        );
        const centerPanelClassNames = classNames(
            "page-content-center-panel", centerPanelClassName
        );
        const leftPanelClassNames = classNames(
            "page-content-left-panel", leftPanelClassName
        );

        return (
            <div className={wrapperClassNames}>
                {header && <div className={headerClassNames}>
                    <div className={appContainer ? (fluid ? "app-container-fluid" : "app-container") : ""}>
                        {header}
                    </div>
                </div>}
                <div className={appContainer ? (fluid ? "page-content-container app-container-fluid" : "page-content-container app-container") : "page-content-container"}>
                    <div className={contentClassNames}>
                        {leftPanel && <div className={leftPanelClassNames}>
                            {leftPanel}
                        </div>}
                        <div className={centerPanelClassNames}>
                            {children}
                        </div>
                        {rightPanel && <div className={rightPanelClassNames}>
                            {rightPanel}
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default PageContent;
